import { ToastMessages } from "../../../../../components/toasts/toastMessages";
import { DxCodeConfigTab } from "../../../../../../shared/enums/dxCodeConfigTab";
import { createNccnIcdConfig } from "../../../../../redux/slice/nccnIcdConfigSlice";
import { createNccnRegimenConfig } from "../../../../../redux/slice/nccnRegimenConfigSlice";
import { AppDispatch } from "../../../../../redux/store/store";

export interface CreateConfigData {
  jCode?: string;
  regimenCode?: string;
  regimenName?: string;
  usePrevious: "yes" | "no";
  selectedId: string;
}

export const createConfig = async (
  dispatch: AppDispatch,
  activeTab: DxCodeConfigTab,
  data: CreateConfigData,
): Promise<void> => {
  if (data.usePrevious === "yes" && !data.selectedId?.trim()) {
    throw new Error(ToastMessages.DX_CODE_CONFIG_SELECT_PREVIOUS_REQUIRED);
  }
  if (activeTab === DxCodeConfigTab.DRUG) {
    if (!data.jCode) {
      throw new Error("J Code is required");
    }

    await dispatch(
      createNccnIcdConfig(
        {
          code: data.jCode,
          category: "", // Will be set by user later or can be added to modal
          description: "",
          icd_codes: [], // Will be overridden if copying from previous config
          total_codes: 0, // Will be overridden if copying from previous config
          created_date: new Date().toISOString(),
        },
        data.usePrevious === "yes" ? data.selectedId : undefined,
      ),
    );
  } else {
    if (!data.regimenCode || !data.regimenName) {
      throw new Error("Regimen Code and Name are required");
    }

    await dispatch(
      createNccnRegimenConfig(
        {
          regimen_code: data.regimenCode,
          regimen_name: data.regimenName,
          icdcodes: [], // Will be overridden if copying from previous config
        },
        data.usePrevious === "yes" ? data.selectedId : undefined,
      ),
    );
  }
};
